import {Colors} from "../consts/Colors.js"
import {tags} from "../consts/Tags.js"

export default class RoundedButton extends Phaser.GameObjects.Container {
    constructor(scene, x, y, w, h, texte, colorText, colorButton, fontSize) {
        // Create container
        super(scene, x, y, []);
        scene.add.existing(this);

        // Add variable
        this.scene = scene;
        this.depth = 1;

        const radius = h/2;
        this.strokeWidth = 3;
        this.durationAnim = 400;

        this.colorText = colorText;
        this.colorButton = colorButton;

        if(fontSize == undefined){
            this.fontSize = "40px"
        }else{
            this.fontSize = fontSize + "px"
        }

        this.text = texte;
        this.locked = false;

        // Add objects
        this.rectButton = this.scene.add.rexRoundRectangle(0, 0, w, h, radius, Colors.Elmt.White);
        this.rectButton.setStrokeStyle(this.strokeWidth, this.colorButton, 1);
        this.add(this.rectButton);

        this.textButton = this.scene.add.rexTagText(0, 0, this.text, {
            fontSize: this.fontSize,
            fontFamily: 'MassiliaMedium',
            fontStyle: 'bold',
            color: this.colorText,
            backgroundColor: 'transparent',
            align: "center",
            wrap: {
                mode: 'word',
                width: (w - 10)
            },
            tags: tags
        });
        this.textButton.setOrigin(0.5)
        this.add(this.textButton);

        // Add interaction
        this.setSize(this.rectButton.width, this.rectButton.height);
        this.setInteractive({useHandCursor: true});

        this.on('pointerover', function (){
            if(!this.locked)
                this.pointerOver();
        });

        this.on('pointerout', function (){
            if(!this.locked)
                this.pointerOut();
        });

    }

    setClickFunction(func){
        this.on('pointerup', () => {
            func();
        })
    }

    pointerOver(){
        this.rectButton.setFillStyle(this.colorButton, 1);
        this.textButton.setFill(Colors.Text.White);
    }

    pointerOut(){
        this.rectButton.setFillStyle(Colors.Elmt.White, 1);
        this.textButton.setFill(this.colorText);
    }

    setLocked(){
        this.disableInteractive();
        this.locked = true
        this.setAlpha(0.5)
    }

    setUnlocked(){
        this.setInteractive();
        this.setAlpha(1)
        this.locked = false
        this.pointerOut();
    }

    // -- Modif du text
    setTextColor(color){
        this.textButton.color = color
    }

    setTextFont(fontFamily){
        this.textButton.fontFamily = fontFamily
    }

    setTextSize(fontSize){
        this.textButton.fontSize = fontSize
    }

}